import { useMatchStore } from "../store/useMatchStore";


export const updateCachedMatchesAfterAction = async (matchId: number) => {
  const matchStore = useMatchStore.getState();
  const { cachedMatches, currentPage, getMatch } = matchStore;

  // Remove match from cache
  const updatedCachedMatches = cachedMatches.filter(match => match.id !== matchId);

  // Update cached state
  useMatchStore.setState({ cachedMatches: updatedCachedMatches });

  // Show next match from cache or fetch next page
  if (updatedCachedMatches.length > 0) {
    const newRows = updatedCachedMatches.slice(currentPage * 1, (currentPage + 1) * 1);
    useMatchStore.setState({ rows: newRows });
  } else {
    await getMatch(currentPage + 1);
  }
};
